import type { ImageAspectRatio } from '@shared/types/image.ts';
import type { TileImage } from '@shared/types/types.ts';
import { isCuttableForLayout } from '@tilelist/domain/composition/ImageCropping.ts';
import { isProductItem } from '@tilelist/domain/composition/TileListitem.ts';
import type { ProductItem } from '@tilelist/domain/composition/TileListitem.ts';
import type { TileListPageLayout } from '@tilelist/domain/composition/TileListPage.ts';

/**
 *
 *
 *
 *
 *
 */
export function visualRefreshFlexLabels(image: TileImage | undefined, aspectRatio: ImageAspectRatio): string[] {
    const labels = [
        isCuttableForLayout(image?.cuttable, aspectRatio) && 'cut',
        image?.grayBackground === true && 'grayBackground',
    ].filter((label): label is string => !!label);
    return labels.length > 0 ? labels : ['none'];
}

function flexLabelsForItem(item: ProductItem, aspectRatio: ImageAspectRatio): string[] | undefined {
    const variation = item.variations.find((v) => v.variationId === item.currentVariationId);
    if (!variation) return undefined;
    return visualRefreshFlexLabels(variation.images[0], aspectRatio);
}

/*                                                                                                    */
export function withVisualRefreshFeatureLabels(pageView: TileListPageLayout): TileListPageLayout {
    const { imageAspectRatio } = pageView.context.layout;

    return {
        ...pageView,
        tileListItems: pageView.tileListItems.map((item) => {
            if (!isProductItem(item)) return item;

            const flexLabels = flexLabelsForItem(item, imageAspectRatio);
            if (!flexLabels) return item;

            return {
                ...item,
                product: {
                    ...item.product,
                    featureTracking: { ...item.product.featureTracking, san_ReptileExperimentFlexLabel: flexLabels },
                },
            };
        }),
    };
}

/**
 *
 *
 *
 *
 *
 */
export function withVisualRefreshClickLabel(item: ProductItem, aspectRatio: ImageAspectRatio): ProductItem {
    const flexLabels = flexLabelsForItem(item, aspectRatio);
    if (!flexLabels) return item;

    return {
        ...item,
        product: {
            ...item.product,
            clickTracking: { ...item.product.clickTracking, 'wk.san_ReptileExperimentFlexLabel': flexLabels },
        },
    };
}
